import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsDownloadNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.625 4v6.491L11.5 7.616l.884.884-3.942 3.942a.625.625 0 01-.884 0L3.616 8.5l.884-.884 2.875 2.875V4z" />
        <path d="M8 0a8 8 0 100 16A8 8 0 008 0zM1.25 8a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0z" />
      </g>
    </svg>
  )
);
SvgActionsDownloadNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsDownloadNormalXsmall;
